import React, { FC, ReactNode } from "react";
import { Alert } from "antd";
import { useTpaPortalConfig } from "../../../hooks/useTpaPortalConfig";
import PortalWebView from "./PortalWebView";
import "./PortalWebView.css";

type TpaPortalStageLayoutProps = {
  visitStageName?: string | null;
  children: ReactNode;
};

/**
 * Stage form/details first, then a compact Open portal button.
 * EMAIL portalUse: no portal UI (same as before feature).
 */
const TpaPortalStageLayout: FC<TpaPortalStageLayoutProps> = ({
  visitStageName,
  children,
}) => {
  const { config, loading, skipPortalUi } = useTpaPortalConfig({
    visitStageName,
    enabled: true,
  });

  if (skipPortalUi) {
    return <>{children}</>;
  }

  return (
    <div className="tpa-portal-stage-layout">
      <div className="tpa-portal-form-slot">{children}</div>

      <div className="tpa-portal-after-details">
        {loading ? (
          <PortalWebView config={null} loading />
        ) : config ? (
          <PortalWebView config={config} />
        ) : (
          <Alert
            type="info"
            showIcon
            message="No portal URL configured"
            description="Add a portal URL under Insurance Setup for this scheme (Website / IHX)."
            style={{ marginBottom: 0 }}
          />
        )}
      </div>
    </div>
  );
};

export default TpaPortalStageLayout;
